import { render, staticRenderFns } from "./SpyderView.vue?vue&type=template&id=21bed292&scoped=true"
import script from "./SpyderView.vue?vue&type=script&lang=js"
export * from "./SpyderView.vue?vue&type=script&lang=js"
import style0 from "./SpyderView.vue?vue&type=style&index=0&id=21bed292&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21bed292",
  null
  
)

export default component.exports